import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import Navigation from '../Components/Navigation';
import NavigationMobile from '../Components/NavigationMobile';
import useIsMobile from '../Hooks/useIsMobile';

const NavigationContainer = () => {
  const { contentLinks } = useSelector((state) => state.navigation);
  const isMobile = useIsMobile();

  const [activeMegaMenuLink, setActiveMegaMenuLink] = useState();
  const [megaMenuTimer, setMegaMenuTimer] = useState();

  const onLinkHover = (link) => {
    clearTimeout(megaMenuTimer);
    setMegaMenuTimer(
      setTimeout(() => {
        setActiveMegaMenuLink(link);
        setMegaMenuTimer(null);
      }, 100)
    );
  };

  const onMouseLeaveLink = () => {
    clearTimeout(megaMenuTimer);
    setMegaMenuTimer(
      setTimeout(() => {
        setActiveMegaMenuLink(null);
        setMegaMenuTimer(null);
      }, 100)
    );
  };

  return isMobile ? (
    <NavigationMobile />
  ) : (
    <Navigation
      contentLinks={contentLinks}
      onMouseLeaveLink={onMouseLeaveLink}
      onLinkHover={onLinkHover}
      onMegaMenuClose={() => setActiveMegaMenuLink(null)}
      activeMegaMenuLink={activeMegaMenuLink}
    />
  );
};

export default NavigationContainer;
